import LegalDocumentPage from "../LegalDocumentPage/LegalDocumentPage";
import { termosContent } from "./Termoscontent";

export default function TermosDeUso() {
  return <LegalDocumentPage content={termosContent} />;
}